import React from "react";

import ModalFieldTimezone from "components/ModalFieldTimezone";
import { FieldOption } from "components/FieldSelect/FieldSelect";
import { EditableTableColumn } from "components/EditableTable/EditableTable";
import { withSelectedOption } from "services/withSelectedOption";
import { convertToStringAndAddToObject } from "services/convertToStringAndAddToObject";

type Params<T> = {
	initialValue: (arg: T) => string;
};

export function columnDefinitionTimezone<T>({
	initialValue
}: Params<T>): EditableTableColumn<T> {
	const field: EditableTableColumn<T>["field"] = ({
		row,
		rowKey,
		isEditing,
		onEdit
	}) => {
		return (
			<ModalFieldTimezone
				isUnlocked={isEditing}
				initialValue={initialValue(row)}
				onOK={(newOptions: FieldOption[]) => {
					withSelectedOption(newOptions, value => {
						const newData = convertToStringAndAddToObject(row, value, rowKey);
						onEdit([{ old: row, new: newData }]);
					});
				}}
			/>
		);
	};

	const output = {
		key: "timezone",
		heading: "Timezone",
		field
	};

	return output;
}
